import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const role = user?.role;
  // Reports expose member address/DOB/contact PII → editor+ only.
  const canSeeReports = role === 'editor' || role === 'admin' || role === 'super_admin';
  const navItems = [
    { to: '/members', label: 'Members' },
    ...(canSeeReports ? [{ to: '/reports', label: 'Reports' }] : []),
    // The control panel is super-admin only.
    ...(role === 'super_admin' ? [{ to: '/users', label: 'Users' }] : []),
  ];

  return (
    <div className="min-h-dvh bg-surface">
      <header className="bg-dcvfd text-white shadow">
        <div className="mx-auto max-w-7xl px-4 flex items-center h-14 gap-6">
          <span className="font-bold tracking-tight whitespace-nowrap">DCVFD Membership</span>
          <nav className="flex items-center gap-1 flex-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                    isActive ? 'bg-white/15 text-white' : 'text-white/75 hover:text-white hover:bg-white/10'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3 text-sm">
            <span className="hidden sm:inline text-white/80">
              {user?.name}
              {user?.role ? <span className="ml-1 text-white/50">({user.role})</span> : null}
            </span>
            <button
              onClick={() => logout()}
              className="rounded-md bg-white/10 px-3 py-1.5 font-medium hover:bg-white/20 transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">{children}</main>
    </div>
  );
}
